<template>
  <div class="flex -mx-3">
    <div class="flex-1 px-3">
      <p>
        {{ packageItem.name }}
      </p>
      <div class="mt-4">
        <BaseBadge v-if="packageItem.upgradesPackageItemId" key="upgrade" orange class="uppercase">
          upgrade
        </BaseBadge>
        <BaseBadge v-else-if="packageItem.optional" key="optional" purple class="uppercase">
          optional
        </BaseBadge>
        <BaseBadge v-else key="optional" silver class="uppercase"> included </BaseBadge>
      </div>
    </div>
    <div class="flex-1 px-3">
      <RouterLink :to="route">
        {{ product.name }}
      </RouterLink>
    </div>
    <div class="w-24 px-3 text-right">{{ packageItem.price }}&euro;</div>
  </div>
</template>

<script>
import { entityComputed } from '@/store/helper';

export default {
  name: 'DataIteratItem',
  props: {
    packageItem: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...entityComputed,
    product() {
      const { productId } = this.packageItem;
      return this.entityById('products', productId);
    },
    route() {
      const { productId: basicProductId } = this.packageItem;
      return {
        name: 'admin.products.basicProducts.basicProduct',
        params: {
          basicProductId,
        },
      };
    },
  },
};
</script>
